import React from 'react'
import { QuestionResultChart } from './QuestionResultChart'
import { ScaleQuestionResults } from '../../types/surveyStore.types'

interface Props {
  questionResult: ScaleQuestionResults
}

export const ScaleQuestionResult: React.FC<React.PropsWithChildren<Props>> = ({
  questionResult,
}) => {
  const {
    scaleAspectResults,
    scaleOptionResultsWithoutScaleAspect,
    totalAnswersWithoutScaleAspect,
  } = questionResult

  if (
    !!scaleOptionResultsWithoutScaleAspect.length &&
    (!!totalAnswersWithoutScaleAspect || totalAnswersWithoutScaleAspect === 0)
  ) {
    const data = scaleOptionResultsWithoutScaleAspect.map((optionResult) => ({
      name: `${optionResult.value}${optionResult.label ? ': ' : ''}${
        optionResult.label
      }`,
      amount: optionResult.total,
    }))

    return (
      <QuestionResultChart
        data={data}
        numberOfAnswers={totalAnswersWithoutScaleAspect}
      />
    )
  }

  return (
    <>
      {scaleAspectResults.map((aspect, i) => {
        const { totalAnswers } = aspect
        const data = aspect.scaleOptionResults.map((optionResult) => ({
          name: `${optionResult.value}${optionResult.label ? ': ' : ''}${
            optionResult.label
          }`,
          amount: optionResult.total,
        }))

        return (
          <QuestionResultChart
            key={i}
            data={data}
            numberOfAnswers={totalAnswers}
            chartLabel={aspect.name}
          />
        )
      })}
    </>
  )
}
